/* eslint-disable */
import storeApis from "../../api/storeApi";
import * as types from "../../constants/AssetLibActionTypes";
import { toast } from "react-toastify";
import Toast from "../../components/assetLibComponents/shared/Toast";
import { Mixpanel } from "../../Mixpanel";

//SET Unauthorization Status
export const setAssetLibUnauthorized = () => {
  //console.log("setUnauthorizedCALLED");
  return (dispatch) => {
    dispatch({ type: "UNAUTHORIZED_ASSET_LIBRARY", payload: null });
  };
};

export const setUnauthorizedAssetUpload = () => {
  // console.log("setUnauthorizedAssetUploadCALLED");
  return (dispatch) => {
    dispatch({ type: "UNAUTHORIZED_ASSET_UPLOAD", payload: null });
  };
};


//Set Publish Type
export const setPublishType = (directPublish) => {
  return async (dispatch) => {
    dispatch({
      type: types.DIRECT_PUBLISH_ASSET,
      payload: directPublish,
    });
  };
};

//Set Edit Asset
export const setEditAsset = (editAsset) => {
  return async (dispatch) => {
    dispatch({
      type: types.EDIT_ASSET,
      payload: editAsset,
    });
  };
};

//Set Selected Asset Publish
export const setSelectedAssetPublish = (asset) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_SELECTED_ASSET_PUBLISH,
      payload: asset,
    });
  };
};

//Logout
export const logout = (authToken) => {
  return async (dispatch) => {
    try {
      const response = await storeApis.get("logout", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        // notify("Logged out successfully!", "success");
        // dispatch({ type: types.DESTROY_SESSION });
        // Toast("Logged out successfully!", "S");
        Mixpanel.track("Logged Out")
        Mixpanel.reset();

        // dispatch({type: types.FETCH_COMPANY_LOGO, payload: null});
        //Toast(response.data.data.message, 'S');
        //console.log("response>>>",response);
        // dispatch({
        //   type: types.FETCH_TOP_MENU,
        //   payload: response.data.data.message,
        // });
      }
    } catch (err) {
      //dispatch({ type: "UNAUTHORIZED", payload: err.response.status });
      //console.log("err>>>",err);
    }
  };
};

//Get Dashboard Content
export const fetchDashboardContent = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.get("dashboard", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        dispatch({ type: types.DEBUGGER_MODE, payload: response.data?.debugger_mode });
        dispatch({
          type: types.FETCH_DASHBOARD_CONTENT,
          payload: response.data.data,
        });
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      // dispatch({ type: "UNAUTHORIZED", payload: err.response.status });
    }
  };
};

//Fetch Hashtag List
export const fetchHashtagList = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "hashtags/list",
        {},
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_ASSET_LIBRARY",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.FETCH_ASSET_LIBRARY_HASHTAG_LIST,
            payload: response.data.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_ASSET_LIBRARY",
        payload: err.response.status,
      });
    }
  };
};

//Create Folder
export const createFolder = (
  authToken,
  smartFolder,
  hashtagList,
  name,
  desc
) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      if (smartFolder === 1) {
        const response = await storeApis.post(
          "folders/add",
          {
            title: name,
            description: desc,
            is_smart: smartFolder,
            hashtags: hashtagList,
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "S");
          }
        }
      } else {
        const response = await storeApis.post(
          "folders/add",
          {
            title: name,
            description: desc,
            is_smart: smartFolder,
            hashtags: 0,
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "S");
          }
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_ASSET_LIBRARY",
        payload: err.response.status,
      });
    }
  };
};

//Add Hashtag
export const addNewHashtag = (authToken, newTitle) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "hashtags/add",
        {
          title: newTitle,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_ASSET_LIBRARY",
        payload: err.response.status,
      });
    }
  };
};

//Fetch Folder List
export const fetchFolderList = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "folders/list",
        {},
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_ASSET_LIBRARY",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.FETCH_ASSET_LIBRARY_FOLDER_LIST,
            payload: response.data.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_ASSET_LIBRARY",
        payload: err.response.status,
      });
    }
  };
};

//Fetch Content List
export const fetchContentList = (authToken, folderID, categoryID, sortBy, searchKey, isBookmark) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      if (folderID) {
        const response = await storeApis.post(
          "folders/assets",
          {
            folder_id: folderID,
            filters:{
              sort_by: sortBy ? sortBy : "0",
              type: isBookmark ? "bookmark" : ""
            }
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_ASSET_LIBRARY",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({
              type: types.FETCH_ASSET_LIBRARY_CONTENT_LIST,
              payload: response.data.data,
            });
            dispatch({ type: "FOLDER", payload: folderID });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          }
        }
      } else {
        const response = await storeApis.post(
          "assets/list",
          {
            filters: {        
                status: "",
                sort_by: sortBy ? sortBy : "0"
            },
            search_keyword: searchKey ? searchKey : "",
            category_id: categoryID ? categoryID : "",
            ignore_ids: [],
            startlimit: 0,
            endlimit: 20
        },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_ASSET_LIBRARY",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({
              type: types.FETCH_ASSET_LIBRARY_CONTENT_LIST,
              payload: response.data.data,
            });
            dispatch({ type: "FOLDER", payload: null });
            dispatch({ type: "SET_ASSET_LIBRARY_CATEGORY_FILTER", payload: categoryID ? categoryID : "" });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          }
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_ASSET_LIBRARY",
        payload: err.response.status,
      });
    }
  };
};

//Ftech Asset Content Details
export const fetchContent = (authToken, content_id, upload) => {
  return async (dispatch) => {
    if (authToken) {
      dispatch({ type: "TOGGLE_LOADING", payload: true });
      try {
        const response = await storeApis.post(
          "assets/list",
          {
            id: upload === "uploadedAsset" ? content_id : [content_id],
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_ASSET_LIBRARY",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({
              type: types.FETCH_ASSET_CONTENT_DETAILS,
              payload: response.data.data,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            dispatch({ type: types.SET_ASSET, payload: content_id });
          }
        }
      } catch (err) {
        // console.log("ERROR", err);
        dispatch({
          type: "UNAUTHORIZED_ASSET_LIBRARY",
          payload: err.response.status,
        });
      }
    } else {
      dispatch({ type: types.SET_ASSET, payload: null });
    }
  };
};

//Fetch Asset Select Type List
export const fetchAssetSelectTypeList = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "assets/asset-types",
        {},
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        dispatch({
          type: types.FETCH_ASSET_SELECT_TYPE_LIST,
          payload: response.data.data,
        });
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      dispatch({ type: "UNAUTHORIZED", payload: err.response.status });
    }
  };
};

//Set Breadcrumb Status
export const setBreadcrumbStatus = (status) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_BREADCRUMB_STATUS,
      payload: status,
    });
  };
};

//Set Selected Asset Type
export const setSelectedAssetType = (assetType) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_SELECTED_ASSET_TYPE,
      payload: assetType,
    });
  };
};

//Set Base Upload Data
export const setBaseUploadData = (baseUpload) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_BASE_UPLOAD_DATA,
      payload: baseUpload,
    });
  };
};

//Set Global Fields Data
export const setGlobalFieldsData = (
  globalFields,
  selectedCategory,
  selectedHashtag
) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_GLOBAL_FIELDS_DATA,
      payload: { globalFields, selectedCategory, selectedHashtag },
    });
  };
};

//Set Selected Categories
export const setSelectedCategories = (categories) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_SELECTED_CATEGORIES,
      payload: categories,
    });
  };
};

//Set Selected Hashtags
export const setSelectedHashtags = (hashtags) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_SELECTED_HASHTAGS,
      payload: hashtags,
    });
  };
};

//Save Global Fields Data
export const saveGlobalFieldsData = (authToken, globalFields) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "assets/add",
        { data: globalFields },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          // if (
          //   response.data.message == "Invalid Credentials" ||
          //   response.data.message == "Unauthenticated" ||
          //   response.data.message == "Unauthorized"
          // ) {
          //   dispatch({
          //     type: "UNAUTHORIZED_ASSET_LIBRARY",
          //     payload: response.data.statusCode,
          //   });
          // } else {
          //   Toast(response.data.message, "E");
          // }
          dispatch({
            type: "UNAUTHORIZED_ASSET_LIBRARY",
            payload: response.data.statusCode,
          });
          // Toast(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.SAVE_GLOBAL_FIELDS_DATA,
            payload: response.data.inserted_ids,
          });

          if (response.data.status == "Success") {
            if (!(response.data.inserted_ids.length > 0)) {
              // console.log("ERR",response.data.message);
            } else {
              // console.log("success",response.data.message);
            }
          }
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      // console.log("response.status>>", err.response.status);
    }
  };
};

//DELETE Asset Content
export const deleteContent = (authToken, asset_id) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "assets/remove",
        {
          id: [asset_id],
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          // if (
          //   response.data.message == "Invalid Credentials" ||
          //   response.data.message == "Unauthenticated" ||
          //   response.data.message == "Unauthorized"
          // ) {
          //   dispatch({
          //     type: "UNAUTHORIZED_ASSET_LIBRARY",
          //     payload: response.data.statusCode,
          //   });
          // } else {
          //   Toast(response.data.message, "E");
          // }
          dispatch({
            type: "UNAUTHORIZED_ASSET_LIBRARY",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.DELETE_ASSET_CONTENT,
            payload: response.data.response,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      dispatch({
        type: "UNAUTHORIZED_ASSET_LIBRARY",
        payload: err.response.status,
      });
      notify(err.response, "error");
    }
  };
};

//Set Asset Bookmark
export const setAssetBookmark = (authToken, id, type, action) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    if (action === "add") {
      try {
        const response = await storeApis.post(
          "bookmarks/add",
          { content_id: id, content_type: type },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            // if (
            //   response.data.message == "Invalid Credentials" ||
            //   response.data.message == "Unauthenticated" ||
            //   response.data.message == "Unauthorized"
            // ) {
            //   dispatch({
            //     type: "UNAUTHORIZED_ASSET_LIBRARY",
            //     payload: response.data.statusCode,
            //   });
            // } else {
            //   Toast(response.data.message, "E");
            // }
            dispatch({
              type: "UNAUTHORIZED_ASSET_LIBRARY",
              payload: response.data.statusCode,
            });
            // Toast(response.data.message, "E");
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({
              type: types.SET_ASSET_BOOKMARK,
              payload: response.data.response,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // notify(response.data.response, "success");
          }
        }
      } catch (err) {
        notify(err.response, "error");
      }
    } else {
      try {
        const response = await storeApis.post(
          "bookmarks/remove",
          { content_id: id, content_type: type },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            // if (
            //   response.data.message == "Invalid Credentials" ||
            //   response.data.message == "Unauthenticated" ||
            //   response.data.message == "Unauthorized"
            // ) {
            //   dispatch({
            //     type: "UNAUTHORIZED_ASSET_LIBRARY",
            //     payload: response.data.statusCode,
            //   });
            // } else {
            //   Toast(response.data.message, "E");
            // }
            dispatch({
              type: "UNAUTHORIZED_ASSET_LIBRARY",
              payload: response.data.statusCode,
            });
            // Toast(response.data.message, "E");
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({
              type: types.SET_ASSET_BOOKMARK,
              payload: response.data.response,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // notify(response.data.response, "success");
          }
        }
      } catch (err) {
        notify(err.response, "error");
      }
    }
  };
};

//Set Asset Library Quick Filter
export const setAssetLibraryQuickFilter = (authToken, id, searchKey, categoryID, folderID) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      if (id === "Bookmarked") {
        const response = await storeApis.post(
          "bookmarks/list",
          { 
            content_type: "0",
            filters: {
                folder_id: folderID ? folderID : "",
                category: categoryID ? categoryID : "",
                type: "bookmark"
            }
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            // if (
            //   response.data.message == "Invalid Credentials" ||
            //   response.data.message == "Unauthenticated" ||
            //   response.data.message == "Unauthorized"
            // ) {
            //   dispatch({
            //     type: "UNAUTHORIZED_ASSET_LIBRARY",
            //     payload: response.data.statusCode,
            //   });
            // } else {
            //   Toast(response.data.message, "E");
            // }
            dispatch({
              type: "UNAUTHORIZED_ASSET_LIBRARY",
              payload: response.data.statusCode,
            });
            // Toast(response.data.message, "E");
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({
              type: types.FETCH_ASSET_LIBRARY_CONTENT_LIST,
              payload: response.data.data,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            dispatch({
              type: "QUICK_FILTERS",
              payload: { id: id, value: value },
            });
            dispatch({ type: "FOLDER", payload: null });
          }
        }
      } else {
        // console.log("<<id>>",id);
        const response = await storeApis.post(
          "assets/list",
          {
            filters: {        
                status: "",
                sort_by: sortBy ? sortBy : "0"
            },
            search_keyword: searchKey ? searchKey : "",
            category_id: id,
            ignore_ids: [],
            startlimit: 0,
            endlimit: 20
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            // if (
            //   response.data.message == "Invalid Credentials" ||
            //   response.data.message == "Unauthenticated" ||
            //   response.data.message == "Unauthorized"
            // ) {
            //   dispatch({
            //     type: "UNAUTHORIZED_ASSET_LIBRARY",
            //     payload: response.data.statusCode,
            //   });
            // } else {
            //   Toast(response.data.message, "E");
            // }
            dispatch({
              type: "UNAUTHORIZED_ASSET_LIBRARY",
              payload: response.data.statusCode,
            });
            // Toast(response.data.message, "E");
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({
              type: types.FETCH_ASSET_LIBRARY_CONTENT_LIST,
              payload: response.data.data,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            dispatch({
              type: "QUICK_FILTERS",
              payload: { id: null, value: null },
            });
            dispatch({ type: "FOLDER", payload: null });
          }
        }
      }
    } catch (err) {
      dispatch({
        type: "UNAUTHORIZED_ASSET_LIBRARY",
        payload: err?.response?.status,
      });
    }
  };
};

//delete folder
export const deleteAssetFolder = (authToken, folderId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "folders/remove",
        {
          id: folderId,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          // if (
          //   response.data.message == "Invalid Credentials" ||
          //   response.data.message == "Unauthenticated" ||
          //   response.data.message == "Unauthorized"
          // ) {
          //   dispatch({
          //     type: "UNAUTHORIZED_ASSET_LIBRARY",
          //     payload: response.data.statusCode,
          //   });
          // } else {
          //   Toast(response.data.message, "E");
          // }
          dispatch({
            type: "UNAUTHORIZED_ASSET_LIBRARY",
            payload: response.data.statusCode,
          });
          // Toast(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          if (response.data.status === "Success") {
            // notify("Folder deleted successfully!", "success");
            Toast("Folder deleted successfully!", "S");
          }
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      //Toast("Something Went Wrong", "E");
      // console.log("ERROR", err);
      dispatch({ type: "UNAUTHORIZED", payload: err.response.status });
    }
  };
};

//EDIT Asset Content
export const editContent = (authToken, newData) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
      "assets/edit",
        newData ,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          // console.log("response.data.statusCode", response.data.statusCode);
          dispatch({
            type: "UNAUTHORIZED_ASSET_LIBRARY",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.EDIT_ASSET_CONTENT,
            payload: response.data.response,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_ASSET_LIBRARY",
        payload: err.response.status,
      });
    }
  };
};

//Fetch Search Content List
export const fetchSearchContentList = (authToken, searchKey) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      if (searchKey) {
        const response = await storeApis.post(
          "assets/list",
          {
            category_id: "",
            search_keyword: searchKey,
            ignore_ids: [],
            startlimit: 0,
            endlimit: 20,
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            // if (
            //   response.data.message == "Invalid Credentials" ||
            //   response.data.message == "Unauthenticated" ||
            //   response.data.message == "Unauthorized"
            // ) {
            //   dispatch({
            //     type: "UNAUTHORIZED_ASSET_LIBRARY",
            //     payload: response.data.statusCode,
            //   });
            // } else {
            //   Toast(response.data.message, "E");
            // }
            dispatch({
                  type: "UNAUTHORIZED_ASSET_LIBRARY",
                  payload: response.data.statusCode,
                });
            // Toast(response.data.message, "E");
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({
              type: types.FETCH_ASSET_LIBRARY_CONTENT_LIST,
              payload: response.data.data,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // dispatch({
            //   type: "QUICK_FILTERS",
            //   payload: { id: null, value: null },
            // });
            // dispatch({ type: "FOLDER", payload: null });
          }
        }
      } else {
        const response = await storeApis.post(
          "assets/list",
          {
            category_id: "",
            search_keyword: "",
            ignore_ids: [],
            startlimit: 0,
            endlimit: 20,
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            // if (
            //   response.data.message == "Invalid Credentials" ||
            //   response.data.message == "Unauthenticated" ||
            //   response.data.message == "Unauthorized"
            // ) {
            //   dispatch({
            //     type: "UNAUTHORIZED_ASSET_LIBRARY",
            //     payload: response.data.statusCode,
            //   });
            // } else {
            //   Toast(response.data.message, "E");
            // }
            dispatch({
              type: "UNAUTHORIZED_ASSET_LIBRARY",
              payload: response.data.statusCode,
            });
            // Toast(response.data.message, "E");
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({
              type: types.FETCH_ASSET_LIBRARY_CONTENT_LIST,
              payload: response.data.data,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // dispatch({
            //   type: "QUICK_FILTERS",
            //   payload: { id: null, value: null },
            // });
            // dispatch({ type: "FOLDER", payload: null });
          }
        }
      }
    } catch (err) {
      dispatch({
        type: "UNAUTHORIZED_ASSET_LIBRARY",
        payload: err.response.status,
      });
    }
  };
};

 



//GET Asset Folder Dropdown List
export const fetchAssetFolderDropdownList = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "assetLibraryList",
        { action: "foldersDropdown" },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          // if (response.data.message == "Invalid Credentials" || response.data.message == "Unauthenticated" || response.data.message == "Unauthorized") {
          //   dispatch({
          //     type: "UNAUTHORIZED_ASSET_LIBRARY",
          //     payload: response.data.statusCode,
          //   });
          // } else {
          //   Toast(response.data.message, "E");
          // }
          dispatch({
            type: "UNAUTHORIZED_ASSET_LIBRARY",
            payload: response.data.statusCode,
          });
          // Toast(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.FETCH_ASSET_FOLDER_DROPDOWN_LIST,
            payload: response.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      dispatch({
        type: "UNAUTHORIZED_ASSET_LIBRARY",
        payload: err?.response?.status,
      });
    }
  };
};

//ADD Asset to Folder
export const addAssetToFolder = (authToken, id, contentList) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        ASSET_LIBRARY_URL,
        {
          action: "addFolderContent",
          content: contentList,
          folder_id: id,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          // if (response.data.message == "Invalid Credentials" || response.data.message == "Unauthenticated" || response.data.message == "Unauthorized") {
          //   dispatch({
          //     type: "UNAUTHORIZED_ASSET_LIBRARY",
          //     payload: response.data.statusCode,
          //   });
          // } else {
          //   Toast(response.data.message, "E");
          // }
          dispatch({
            type: "UNAUTHORIZED_ASSET_LIBRARY",
            payload: response.data.statusCode,
          });
          // Toast(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.ADD_CONTENT_TO_FOLDER,
            payload: response.data.response,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          notify(response.data.message, "success");
        }
      }
    } catch (err) {
      dispatch({
        type: "UNAUTHORIZED_ASSET_LIBRARY",
        payload: err.response.status,
      });
      notify(err.response, "error");
    }
  };
};
